import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { I18NextModule } from 'angular-i18next';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthConfig, AuthInterceptor, AuthModule, AuthService } from './auth/index';
import { AppDateAdapter, ConfigModule, ConfigService, I18NextInterceptor, TranslateModule } from './commons';
import { DirectivesModule } from './commons/directives/directives.module';
import { MastersService } from './masters.service';
import { HomeLargeAccountsComponent } from './modules/home-large-accounts/home-large-accounts.component';
import { HomePymesComponent } from './modules/home-pymes/home-pymes.component';
import { LanguagePickerComponent } from './modules/language-picker/language-picker.component';
import { NewContractDataOfferComponent } from './modules/new-contract-large-accounts/components/new-contract-data-offer/new-contract-data-offer.component';
import { NewContractHiringDataComponent } from './modules/new-contract-large-accounts/components/new-contract-hiring-data/new-contract-hiring-data.component';
import { NewContractModalResumeComponent } from './modules/new-contract-large-accounts/components/new-contract-modal-resume/new-contract-modal-resume.component';
import { NewContractModalSignComponent } from './modules/new-contract-large-accounts/components/new-contract-modal-sign/new-contract-modal-sign.component';
import { NewContractSelectOfferComponent } from './modules/new-contract-large-accounts/components/new-contract-select-offer/new-contract-select-offer.component';
import { NewContractSelectTypeComponent } from './modules/new-contract-large-accounts/components/new-contract-select-type/new-contract-select-type.component';
import { NewContractSelectValuesComponent } from './modules/new-contract-large-accounts/components/new-contract-select-values/new-contract-select-values.component';
import { NewContractSignComponent } from './modules/new-contract-large-accounts/components/new-contract-sign/new-contract-sign.component';
import { NewContractLargeAccountsComponent } from './modules/new-contract-large-accounts/new-contract-large-accounts.component';
import { BusinessNamePymesComponent } from './modules/new-contract-pymes/business-name-pymes/business-name-pymes.component';
import { ConfirmDialogComponent } from './modules/new-contract-pymes/confirm-dialog/confirm-dialog.component';
import { DraftWarningComponent } from './modules/new-contract-pymes/draft-warning/draft-warning.component';
import { ExistingContractDialogComponent } from './modules/new-contract-pymes/existing-contract-dialog/existing-contract-dialog.component';
import { InstallationDataPymesComponent } from './modules/new-contract-pymes/installation-data-pymes/installation-data-pymes.component';
import { NewContractPymesComponent } from './modules/new-contract-pymes/new-contract-pymes.component';
import { PaymentsDataComponent } from './modules/new-contract-pymes/payments-data/payments-data.component';
import { ResumeDialogComponent } from './modules/new-contract-pymes/resume-dialog/resume-dialog.component';
import { CupsDialogComponent } from './modules/new-contract-pymes/risk-analysis-pymes/cups-dialog/cups-dialog.component';
import { DeleteDialogComponent } from './modules/new-contract-pymes/risk-analysis-pymes/delete-dialog/delete-dialog.component';
import { RiskAnalysisPymesComponent } from './modules/new-contract-pymes/risk-analysis-pymes/risk-analysis-pymes.component';
import { TypeSelectionNewContractComponent } from './modules/new-contract-pymes/type-selection-new-contract/type-selection-new-contract.component';
import { UserSelectionNewContractComponent } from './modules/new-contract-pymes/user-selection-new-contract/user-selection-new-contract.component';
import { DownloadOfferDialogComponent } from './modules/new-offer/download-offer-dialog/download-offer-dialog.component';
import { NewOfferComponent } from './modules/new-offer/new-offer.component';
import { RenovateContractPymesFormComponent } from './modules/renovate-contract-pymes/components/renovate-contract-pymes-form/renovate-contract-pymes-form.component';
import { RenovateContractPymesResumeComponent } from './modules/renovate-contract-pymes/components/renovate-contract-pymes-resume/renovate-contract-pymes-resume.component';
import { RenovateContractPymesComponent } from './modules/renovate-contract-pymes/pages/renovate-contract-pymes.component';
import { ReportsComponent } from './modules/reports/reports.component';
import { RiskWarningModalComponent } from './modules/risk-warning-modal/risk-warning-modal.component';
import { UrlService } from './services/url.service';
import { UtilService } from './services/util.service';
import { AnnualSalesObjectivesComponent } from './shared/annual-sales-objectives/annual-sales-objectives.component';
import { AnnualSalesComponent } from './shared/annual-sales/annual-sales.component';
import { CommercialPortfolioComponent } from './shared/commercial-portfolio/commercial-portfolio.component';
import { ContractsNextExpirationComponent } from './shared/contracts-next-expiration/contracts-next-expiration.component';
import { HeaderContractComponent } from './shared/header-contract/header-contract.component';
import { HomeSearchComponent } from './shared/home-search/home-search.component';
import { ModalCookiesComponent } from './shared/modal-cookies/modal-cookies.component';
import { ModalPrivacyPolicyComponent } from './shared/modal-privacy-policy/modal-privacy-policy.component';
import { ModalWarningComponent } from './shared/modal-warning/modal-warning.component';
import { NewContractsComponent } from './shared/new-contracts/new-contracts.component';
import { RiskWarningComponent } from './shared/risk-warning/risk-warning.component';
import { UiModule } from './shared/ui/ui.module';
import { NewContractPymesMultipointComponent } from './modules/new-contract-pymes-multipoint/new-contract-pymes-multipoint.component';
import { MultipointBusinessNamePymesComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-business-name-pymes/multipoint-business-name-pymes.component';
import { MultipointInstallationPymesComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-installation-pymes/multipoint-installation-pymes.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MultipointTypeChargeComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-type-charge/multipoint-type-charge.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MultipointModalHaveInstallationsComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-modal-have-installations/multipoint-modal-have-installations.component';
import { MultipointSignerContractComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-signer-contract/multipoint-signer-contract.component';
import { MultipointModalResumeComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-modal-resume/multipoint-modal-resume.component';
import { MultipointModalErrorCupsComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-modal-error-cups/multipoint-modal-error-cups.component';
import { MultipointModalErrorInstallationComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-modal-error-installation/multipoint-modal-error-installation.component';
import { ModalCancelContractComponent } from './shared/modal-cancel-contract/modal-cancel-contract.component';
import { ModalErrorBankAccountComponent } from './shared/modal-error-bank-account/modal-error-bank-account.component';
import { ImpersonalizeUserComponent } from './modules/impersonalize-user/impersonalize-user.component';
import { MultipointModalErrorEndpointsComponent } from './modules/new-contract-pymes-multipoint/components/multipoint-modal-error-endpoints/multipoint-modal-error-endpoints.component';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { Platform } from '@angular/cdk/platform';
import { UtilValidatorsService } from './commons/validations-format/util-validators.service';
import { MatNativeDateModule } from '@angular/material/core';
import { ModalChooseCountryComponent } from './shared/modal-choose-country/modal-choose-country.component';
import { ChangePasswordComponent } from './modules/change-password/change-password.component';
import { ModalDeleteFactorsComponent } from '@shared/modal-delete-factors/modal-delete-factors.component';
import { SharedModule } from '@shared/shared.module';

registerLocaleData(localeEs, 'es-ES');
registerLocaleData(localePt, 'pt-PT');

const matModules = [
  MatMenuModule,
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatGridListModule,
  MatCheckboxModule,
  MatRadioModule,
  MatSnackBarModule,
  MatTabsModule,
  MatDialogModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatExpansionModule,
  MatTooltipModule
];

@NgModule({
  declarations: [
    AppComponent,
    LanguagePickerComponent,
    HomePymesComponent,
    HomeLargeAccountsComponent,
    HomeSearchComponent,
    ContractsNextExpirationComponent,
    AnnualSalesComponent,
    AnnualSalesObjectivesComponent,
    RiskWarningComponent,
    NewContractsComponent,
    CommercialPortfolioComponent,
    RiskWarningModalComponent,
    NewContractPymesComponent,
    HeaderContractComponent,
    RiskAnalysisPymesComponent,
    BusinessNamePymesComponent,
    InstallationDataPymesComponent,
    DeleteDialogComponent,
    CupsDialogComponent,
    PaymentsDataComponent,
    ResumeDialogComponent,
    UserSelectionNewContractComponent,
    ReportsComponent,
    DraftWarningComponent,
    NewOfferComponent,
    DownloadOfferDialogComponent,
    NewContractLargeAccountsComponent,
    NewContractSelectTypeComponent,
    NewContractSelectOfferComponent,
    NewContractSelectValuesComponent,
    NewContractDataOfferComponent,
    ModalCookiesComponent,
    ModalPrivacyPolicyComponent,
    NewContractHiringDataComponent,
    NewContractSignComponent,
    ModalWarningComponent,
    NewContractModalResumeComponent,
    NewContractModalSignComponent,
    ModalWarningComponent,
    ExistingContractDialogComponent,
    ConfirmDialogComponent,
    RenovateContractPymesComponent,
    RenovateContractPymesFormComponent,
    RenovateContractPymesResumeComponent,
    TypeSelectionNewContractComponent,
    NewContractPymesMultipointComponent,
    MultipointBusinessNamePymesComponent,
    MultipointInstallationPymesComponent,
    MultipointTypeChargeComponent,
    MultipointModalErrorCupsComponent,
    MultipointModalErrorCupsComponent,
    MultipointModalHaveInstallationsComponent,
    MultipointSignerContractComponent,
    MultipointModalResumeComponent,
    MultipointModalErrorInstallationComponent,
    ModalCancelContractComponent,
    ModalErrorBankAccountComponent,
    ImpersonalizeUserComponent,
    MultipointModalErrorEndpointsComponent,
    ModalChooseCountryComponent,
    ChangePasswordComponent,
    ModalDeleteFactorsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule,
    TranslateModule,
    I18NextModule,
    ConfigModule,
    UiModule,
    HttpClientModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    FormsModule,
    ReactiveFormsModule,
    matModules,
    DirectivesModule,
    SharedModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: I18NextInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: 'Window', useValue: typeof window !== 'undefined' && window },
    { provide: DateAdapter, useClass: AppDateAdapter, deps: [ MAT_DATE_LOCALE, Platform ] },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    MastersService,
    UrlService,
    UtilService,
    UtilValidatorsService
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
  constructor(auth: AuthService, config: ConfigService) {
    const authConfig: AuthConfig = {
      issuer: config.get('auth.authority'),
      redirectUri: config.get('auth.redirectUri'),
      clientId: config.get('auth.clientID'),
      oidc: true,
      responseType: 'code',
      requestAccessToken: true,
      scope: config.get('auth.scopes'),
      postLogoutRedirectUri: config.get('auth.postLogoutRedirectUri')
      // resource: config.get('prefixes.default')
    };
    auth.configure(authConfig);
  }
}
